import { type Load } from '@sveltejs/kit';
import {
  getDailyMode,
  getPuzzleKeyFromURL,
  getStreakQueryKey,
  stringifyPuzzleKey,
} from '~/lib/queries.svelte';
import { getDailyStreak } from '~/lib/analytics.remote.js';
import { getDailyPuzzle } from '~/lib/puzzles.remote.js';
import type { GameType } from '~/types';

export const load: Load = async (event) => {
  const { queryClient, isPremium } = await event.parent();

  const mode = getDailyMode(event.params.mode as GameType);

  const streakKey = getStreakQueryKey(mode);
  if (isPremium && !queryClient.getQueryData(streakKey)) {
    await queryClient.prefetchQuery({
      queryKey: streakKey,
      queryFn: () => getDailyStreak(mode),
    });
  }
  // already in cache
  const key = getPuzzleKeyFromURL(event);
  if (queryClient.getQueryData(['daily', key])) {
    return;
  }
  const params = new URLSearchParams(key);
  let puzzle;
  try {
    puzzle = await getDailyPuzzle({
      mode: params.get('mode'),
      date: params.get('date'),
      puzzle: params.get('puzzle'),
    });
  } catch {
    // Transient network failures (e.g. Safari "Load failed" when the app is
    // backgrounded) shouldn't fail navigation; puzzleQuery in +page.svelte
    // fetches (and retries) the puzzle on the client.
    return;
  }
  // TODO figure out how to handle this
  if (puzzle) {
    await queryClient.prefetchQuery({
      queryKey: ['daily', key],
      queryFn: () => puzzle,
    });
    if (key.match(/date=latest/)) {
      await queryClient.prefetchQuery({
        queryKey: ['daily', stringifyPuzzleKey(puzzle)],
        queryFn: () => puzzle,
      });
    }
  }
};
